export default __webpack_public_path__ + "static/media/Ellipse 72.b71e1e9b.svg";